import React from 'react';
import PropTypes from 'prop-types';

/**
 * Toast notification component.
 * Auto-dismisses after 3 seconds (handled by parent).
 *
 * @param {{ message: string|null, type: 'success'|'info'|'error' }} props
 */
const Toast = ({ message, type = 'success' }) => {
  if (!message) return null;

  const iconMap = {
    success: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
        <polyline points="20 6 9 17 4 12" />
      </svg>
    ),
    info: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="16" x2="12" y2="12" />
        <line x1="12" y1="8" x2="12.01" y2="8" />
      </svg>
    ),
    error: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
        <circle cx="12" cy="12" r="10" />
        <line x1="15" y1="9" x2="9" y2="15" />
        <line x1="9" y1="9" x2="15" y2="15" />
      </svg>
    ),
  };

  return (
    <div className={`qs-toast qs-toast-${type}`} role="alert" aria-live="polite">
      <span className="qs-toast-icon">{iconMap[type] || iconMap.success}</span>
      <span>{message}</span>
    </div>
  );
};

Toast.propTypes = {
  message: PropTypes.string,
  type: PropTypes.oneOf(['success', 'info', 'error']),
};

Toast.displayName = 'Toast';

export default Toast;
